export default "__VITE_ASSET__ByeD$k6N__"